import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import errorModal from "../../../services/errorModal.service";
import { WithdrawalRevertRequest } from "../../withdraw/models";
import { walletHistoryAPI } from "../api/wallethistory.api";
import { WalletHistoryRequest } from "../models/request/walletHistoryRequest";
import { LastWithdrawalResponse } from "../models/response/lastWithdrawalResponse";
import { WalletHistoryResponse } from "../models/response/walletHistoryResponse";

const walletHistoryService = {
  getWalletHistory: async (request: WalletHistoryRequest,): Promise<WalletHistoryResponse | null> => {
    var response = await walletHistoryAPI.getWalletHistoryApi(request);
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response.data ?? null;
  },

  getWithdrawalLastRequest: async (): Promise<UnifiedResponse<LastWithdrawalResponse>> => {
    var response = await walletHistoryAPI.withdrawalLastRequestApi();
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response;
  },

  cancelWithdraw: async (request: WithdrawalRevertRequest): Promise<UnifiedResponse<any>> => {
    var response = await walletHistoryAPI.userWithdrawRevertApi(request);
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response;
  },
}

export default walletHistoryService;